import React from 'react';
import { footerData } from '../data';
import { contactData } from '../data';
import { motion } from 'framer-motion';
import { fadeIn } from '../variants';

const staggerContainer = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.3,
      delayChildren: 0.2,
    },
  },
};

const Footer = () => {
  const { info} = contactData;
  const { about, links, program } = footerData; //newsletter
  return (
    <footer className='section bg-dark lg:py-10 xl:pb-20"'>
      <div className='container mx-auto'>
        <motion.div 
        variants={staggerContainer}
        initial='hidden'
        whileInView={'show'}
        viewport={{once:false, amount:0.1}}
        className='text-white flex flex-col lg:flex-row lg:justify-between gap-x-5 gap-y-14'>
          <motion.div variants={fadeIn('up')} className='flex-1 flex flex-col gap-y-6'>
            <div className='font-primary text-xl uppercase tracking-[0.08em]'>
              {about.title}</div>
            <div className='leading-relaxed text-[#dbdbdb]'>{about.subtitle}</div>
            <div className='flex flex-col gap-y-4 font-semibold text-[#dbdbdb]'>
              {/* <div className='flex items-center gap-x-[10px]'>
                <div>{about.address.icon}</div>
                <div>{about.address.name}</div>
              </div>
              <div className='flex items-center gap-x-[10px]'>
                <div>{about.phone.icon}</div>
                <div>{about.phone.number}</div>
              </div>
              <div className='flex items-center gap-x-[10px]'>
                <div>{about.email.icon}</div>
                <div>{about.email.address}</div>
              </div> */}
              {info.map((item,index)=>{
              const {title,address, phone, email, link }= item;
              return (
                <div key={index}>
                  <div className='font-primary uppercase font-medium text-xl mb-3'>{title}</div>
                  <div className='flex flex-col gap-y-3 mb-8'>
                    <div className='flex items-centre gap-[10px]'>
                      <div>{address.icon}</div>
                      <div className='font-medium'>{address.name}</div>
                    </div>

                    <div className='flex items-centre gap-[10px]'>
                      <div>{phone.icon}</div>
                      <div className='font-medium' >{phone.number}</div>
                    </div>

                    <div className='flex items-centre gap-[10px]'>
                      <div>{email.icon}</div>
                      <div className='font-medium'>{email.address}</div>
                    </div>
                    <a className='font-medium border-b border-red-500 pb-[5px]' href='https://g.co/kgs/GQ1CYmC'>
                      {link}
                    </a>
                  </div>
                </div>
              );
            })}
          </div>
          </motion.div>
          <motion.div variants={fadeIn('up')} className='flex-1 flex flex-col xl:items-center'>
            <div>
              <div className='font-primary text-xl uppercase tracking-[0.08em] mb-6'>
                {links.title}</div>
              <ul className='flex flex-col gap-y-4 text-[#dbdbdb]'>
                {links.items.map((item,index)=>{
                  // const {href,name} = item;
                  return <li key={index}>
                    {/* <a className='hover:text-white transition'>{name}</a> */}
                    <a className='link hover:border-b-2 hover:border-red-400 transition duration-300 capitalize' href={item.href}>{item.name}</a>
                  </li>
                })}
              </ul>
            </div>
          </motion.div>
          <motion.div variants={fadeIn('up')} className='flex-1'>
            <div className='font-primary text-xl uppercase tracking-[0.08em] mb-6'>{program.title}</div>
            <ul className='flex flex-col gap-y-4 text-[#dbdbdb]'>
              {program.items.map((item,index)=>{
                return <li key={index}>
                  {item.name}
                </li>;
              })}
            </ul>
          </motion.div>
          {/* will work on it later not required yet ss */}
          {/* <div className='flex-1'>newsletter</div> */}
        </motion.div>
      </div>
    </footer>

  );
};

export default Footer;
